'use client';

import { useEffect, useState } from 'react';
import { DMImage } from '@/components/custom-image/custom-image';
import DMDialog from '@/components/dialog';
import useDialog from '@/hooks/useDialog';
import { badges } from '@/lib/badges';
import { cn } from '@/lib/utils';
import useLoyaltyStore from '@/lib/zustand/store/loyaltyStore';
import { Loader } from 'lucide-react';
import Confetti from 'react-confetti';

function ConfettiDialog() {
  const { isOpen, hide } = useDialog({ name: 'levelUp' });
  const [badge, setBadge] = useState<any>();
  const { loyaltyData: userData } = useLoyaltyStore();

  useEffect(() => {
    if (userData) {
      getLevelIcon(userData?.userLevel?.level);
    }
  }, [userData]);

  const getLevelIcon = (level: number) => {
    const item: any = badges.filter(badge => {
      if (badge.level == level) return badge;
    });
    setBadge(item[0]);
  };
  return (
    <>
      {isOpen && (
        <>
          <Confetti className='!z-[100]' width={2000} height={1000} numberOfPieces={300} />
          <DMDialog
            open={isOpen}
            className=' w-full'
            setOpen={hide}
            content={
              <div className='flex flex-col items-center justify-start p-10'>
                {badge ? (
                  <div className='flex flex-col items-center justify-center'>
                    <div className='relative bg-brand-secondary rounded-full border border-brand-primary-border '>
                      <DMImage
                        src={badge?.icon as string}
                        alt='Badge'
                        width={70}
                        height={70}
                        className='p-2 object-fit h-28 w-28 animate-gray-to-color'
                      />
                      <span
                        className={cn(
                          '-z-50 absolute top-0 left-0 inline-flex h-full w-full rounded-full opacity-75',
                          'animate-ping-badge',
                          badge?.progressColor
                        )}
                      />
                    </div>
                    <h3 className={cn('mt-4', badge.textColor)}>{badge?.name}</h3>
                  </div>
                ) : (
                  <Loader className='animate-spin opacity-45' />
                )}
                <div className='w-full flex flex-col items-center mb-2 p-6'>
                  <h2 className='text-4xl text-white'>Bravo!</h2>
                  <p className='text-base font-semibold'>You have achieved a higher level!</p>
                </div>
              </div>
            }
          />
        </>
      )}
    </>
  );
}

export default ConfettiDialog;
